import {
  Layers,
  Gift,
  PlusCircle,
  SlidersHorizontal,
  Megaphone,
  BadgeCheck,
  Store,
  Link2,
  ShoppingBag,
  Tag,
  type LucideIcon,
} from 'lucide-react';

export interface TradeableTypeMeta {
  label: string;
  blurb: string;
  icon: LucideIcon;
  /** Tailwind classes for the icon tile (bg + text). */
  accent: string;
  order: number;
}

/**
 * `totid` → presentation metadata. The list endpoint doesn't join the
 * tradeable_object_type row, so labels/icons are curated here from the known
 * catalog. Unknown types fall back to a generic tile.
 */
export const TRADEABLE_TYPE_META: Record<number, TradeableTypeMeta> = {
  7: { label: 'Homepage Sliders', blurb: 'Featured hero slider placements', icon: SlidersHorizontal, accent: 'bg-blue-600 text-white', order: 1 },
  8: { label: 'Adverts & Promos', blurb: 'In-app adverts and external link promos', icon: Megaphone, accent: 'bg-indigo-600 text-white', order: 2 },
  1: { label: 'Listing Plans', blurb: 'Trader listing subscriptions by tier', icon: Layers, accent: 'bg-violet-600 text-white', order: 3 },
  15: { label: 'Shopper Plans', blurb: 'Buyer-side subscription plans', icon: ShoppingBag, accent: 'bg-teal-600 text-white', order: 4 },
  12: { label: 'Store Subscriptions', blurb: 'Storefront plans for businesses', icon: Store, accent: 'bg-emerald-600 text-white', order: 5 },
  6: { label: 'Listing Add-ons', blurb: 'Extra photos, videos and virtual tours', icon: PlusCircle, accent: 'bg-amber-500 text-white', order: 6 },
  13: { label: 'Store Add-ons', blurb: 'Impression, view and media boosts', icon: PlusCircle, accent: 'bg-orange-500 text-white', order: 7 },
  10: { label: 'Verification', blurb: 'Identity and business verification badges', icon: BadgeCheck, accent: 'bg-sky-600 text-white', order: 8 },
  14: { label: 'Permalinks', blurb: 'Custom vanity URLs with analytics', icon: Link2, accent: 'bg-fuchsia-600 text-white', order: 9 },
  5: { label: 'Free Plan', blurb: 'Complimentary starter plans', icon: Gift, accent: 'bg-green-600 text-white', order: 10 },
};

export const getTypeMeta = (totid: number): TradeableTypeMeta =>
  TRADEABLE_TYPE_META[totid] ?? {
    label: `Type ${totid}`,
    blurb: 'Tradeable objects',
    icon: Tag,
    accent: 'bg-gray-600 text-white',
    order: 999,
  };
